import React from 'react';
import T from 'prop-types';
import { useSelector } from 'react-redux';

import AppsLine from '../../_shared/components/AppsLine';
import SectionSummary from '../../_shared/components/SectionSummary';
import { aiDashboardAppsSelector } from '../selectors';

const TrendsSummary = ({ allowQV }) => {
  const apps = useSelector(aiDashboardAppsSelector);

  return (
    <SectionSummary
      title="Behavioral Trends"
      description="Track AI user behaviors and quantify the impact of AI apps on non-AI sectors."
    >
      <AppsLine
        apps={apps.data?.top_apps}
        settings={apps.settings}
        placeholderLimit={5}
        allowQV={allowQV}
      />
    </SectionSummary>
  );
};

TrendsSummary.propTypes = {
  allowQV: T.bool.isRequired,
};

export default TrendsSummary;
